@if ((theftReports | async).length > 0) {
  <div
    class="alert-container px-4 mt-4"
    panRole
    [roles]="['admin', 'branch-owner', 'branch-manager', 'market-manager', 'validator', 'location-manager']"
  >
    <app-theft-notice-alert></app-theft-notice-alert>
  </div>
}

@if (theftReportDatagrid()?.showCrossCaseWarning()) {
  <div class="alert-container px-4 mt-4">
    <app-pan-inline-alert type="danger">Select incidents only from the same cases to create an Asset Recovery Report.</app-pan-inline-alert>
  </div>
}

<app-pan-card
  class="block mb-20"
  [isPageContainer]="true"
  pageContainerSize="xl"
  header="Suspicious Incidents Report"
  [subheader]="pageSubheader()"
  [secondarySubheader]="timezoneSubheader()"
>
  @if (loadingData()) {
    <app-pan-blank-slate> <app-pan-spinner></app-pan-spinner> &nbsp;Loading... </app-pan-blank-slate>
  } @else {
    @if (completedCount() > 0) {
      <app-pan-inline-alert
        panRole
        [roles]="['admin', 'branch-owner', 'branch-manager', 'market-manager', 'location-manager']"
        type="primary"
        class="my-2"
      >
        You currently have {{ completedCount() }} additional incident(s) undergoing quality assurance review
      </app-pan-inline-alert>
    }

    <app-theft-report-datagrid
      [shareKey]="shareKey()"
      [theftReports]="theftReports | async"
      [locationName]="locationName()"
      [locationId]="locationId()"
      [branchName]="branchName()"
      [branchId]="branchId()!"
      [assetRecoveryEnabled]="assetRecoveryEnabled()"
      (mergeCasesEvent)="onMergeCases($event)"
      (markNoTheftEvent)="onMarkNoTheft($event)"
      [hideBranchCurrency]="hideCurrency()"
    ></app-theft-report-datagrid>

    @if (!dataLoaded()) {
      <app-pan-inline-alert class="mt-5" type="danger">
        {{ errorMessage() }}
      </app-pan-inline-alert>
    }
  }
</app-pan-card>

@if (dataLoaded()) {
  <app-footer [public]="true" [copyright]="true"></app-footer>
}
